import React from 'react';
import { Archive, Clock, CheckCircle } from 'lucide-react';
import Icon from '../../../components/AppIcon';


const TABS = [
  { key: 'archived', label: 'Arhivirani', icon: Archive, color: 'text-gray-600', activeBg: 'bg-gray-100', activeBorder: 'border-gray-500', activeText: 'text-gray-700' },
  { key: 'expired', label: 'Istekli', icon: Clock, color: 'text-orange-500', activeBg: 'bg-orange-50', activeBorder: 'border-orange-400', activeText: 'text-orange-700' },
  { key: 'completed', label: 'Završeni', icon: CheckCircle, color: 'text-teal-600', activeBg: 'bg-teal-50', activeBorder: 'border-teal-500', activeText: 'text-teal-700' },
];

export default function ArchiveTabBar({ activeTab, onTabChange, counts }) {
  return (
    <div className="flex gap-1 bg-gray-100 p-1 rounded-xl overflow-x-auto">
      {TABS?.map((tab) => {
        const Icon = tab?.icon;
        const isActive = activeTab === tab?.key;
        const count = counts?.[tab?.key] ?? 0;
        return (
          <button
            key={tab?.key}
            onClick={() => onTabChange(tab?.key)}
            className={`flex items-center gap-2 px-4 py-2.5 rounded-lg text-sm font-medium transition-all whitespace-nowrap flex-1 justify-center ${
              isActive
                ? `bg-white shadow-sm border ${tab?.activeBorder} ${tab?.activeText}`
                : 'text-gray-500 hover:text-gray-700 hover:bg-white/50'
            }`}
          >
            <Icon size={16} className={isActive ? tab?.color : 'text-gray-400'} />
            <span>{tab?.label}</span>
            {count > 0 && (
              <span className={`inline-flex items-center justify-center min-w-[20px] h-5 px-1.5 rounded-full text-xs font-bold ${
                isActive ? `${tab?.activeBg} ${tab?.activeText}` : 'bg-gray-200 text-gray-600'
              }`}>
                {count}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
